import type { Etape } from '@dinertournant/core';

const base = { width: 18, height: 18, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' } as const;

/** Icônes d'étape : feuille (entrée), cloche (plat), gâteau (dessert). Décoratives, le libellé porte le sens. */
export function IconeEtape({ etape, taille = 18 }: { etape: Etape; taille?: number }) {
  const p = { ...base, width: taille, height: taille, 'aria-hidden': true };
  if (etape === 'entree')
    return (
      <svg {...p}>
        <path d="M5 19c0-8 6-14 14-14 0 8-6 14-14 14z" />
        <path d="M5 19l7-7" />
      </svg>
    );
  if (etape === 'plat')
    return (
      <svg {...p}>
        <path d="M3 17h18" />
        <path d="M5 17a7 7 0 0 1 14 0" />
        <path d="M12 10V8" />
        <path d="M10.5 8h3" />
      </svg>
    );
  return (
    <svg {...p}>
      <path d="M7 12h10l-1.6 7H8.6z" />
      <path d="M6 12a6 4.5 0 0 1 12 0" />
      <path d="M12 5.5V4" />
    </svg>
  );
}

/** Étape commune : deux verres qui trinquent. */
export function IconeCommune({ taille = 18 }: { taille?: number }) {
  return (
    <svg {...base} width={taille} height={taille} aria-hidden="true">
      <path d="M8 4h2l-1 8a2.5 2.5 0 0 1-5 0L3 4h2" />
      <path d="M6.5 14.5V20M4 20h5" />
      <path d="M14 4h2l-1 8a2.5 2.5 0 0 1-5 0L9 4h2" transform="translate(5 0)" />
      <path d="M17.5 14.5V20M15 20h5" />
    </svg>
  );
}

export function IconeMaison({ taille = 18 }: { taille?: number }) {
  return (
    <svg {...base} width={taille} height={taille} aria-hidden="true">
      <path d="M4 11l8-6 8 6v8H4z" />
      <path d="M10 19v-5h4v5" />
    </svg>
  );
}

export function IconeCoche({ taille = 18 }: { taille?: number }) {
  return (
    <svg {...base} width={taille} height={taille} strokeWidth={2.2} aria-hidden="true">
      <path d="M5 12l5 5 9-10" />
    </svg>
  );
}

export function IconeAttention({ taille = 20 }: { taille?: number }) {
  return (
    <svg {...base} width={taille} height={taille} aria-hidden="true">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 8v5" />
      <path d="M12 16h.01" />
    </svg>
  );
}

export function IconeInfo({ taille = 20 }: { taille?: number }) {
  return (
    <svg {...base} width={taille} height={taille} aria-hidden="true">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v5" />
      <path d="M12 8h.01" />
    </svg>
  );
}

export function IconeActualiser({ taille = 18 }: { taille?: number }) {
  return (
    <svg {...base} width={taille} height={taille} aria-hidden="true">
      <path d="M20 12a8 8 0 1 1-2.3-5.7" />
      <path d="M20 4v5h-5" />
    </svg>
  );
}

export function IconePoignee() {
  return (
    <svg width="12" height="18" viewBox="0 0 12 18" fill="currentColor" aria-hidden="true">
      <circle cx="3" cy="3" r="1.5" />
      <circle cx="9" cy="3" r="1.5" />
      <circle cx="3" cy="9" r="1.5" />
      <circle cx="9" cy="9" r="1.5" />
      <circle cx="3" cy="15" r="1.5" />
      <circle cx="9" cy="15" r="1.5" />
    </svg>
  );
}

export function IconeMemeFoyer() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <circle cx="9" cy="12" r="5" />
      <circle cx="15" cy="12" r="5" />
    </svg>
  );
}

/** Enveloppe : renvoi d'un e-mail. */
export function IconeEnveloppe({ taille = 18 }: { taille?: number }) {
  return (
    <svg {...base} width={taille} height={taille} aria-hidden="true">
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 7l9 6 9-6" />
    </svg>
  );
}

export function IconeAgenda({ taille = 18 }: { taille?: number }) {
  return (
    <svg {...base} width={taille} height={taille} aria-hidden="true">
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M3 10h18" />
      <path d="M8 3v4" />
      <path d="M16 3v4" />
    </svg>
  );
}
